import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

const LogoutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };

  return (
    <Button
      variant="text"
      color="error"
      onClick={handleLogout}
      aria-label="Sign out"
      sx={{
        flexShrink: 0,
        minWidth: { xs: 44, sm: 64 },
        px: { xs: 1, sm: 2 },
        "& .MuiButton-startIcon": { mr: { xs: 0, sm: 1 } },
      }}
      startIcon={<LogoutIcon />}
    >
      <span className="sign-out-label">Sign Out</span>
    </Button>
  );
};

export default LogoutButton;
